import "./InputTypeaheadResultTemplate.html";

import type { IAttributes, IDirective } from "angular";
import { module } from "angular";
import { isNil } from "lodash";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";

export default class InputTypeaheadDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        createNew: "<?",
        irLabel: "<",
        irOptions: "<",
        irPlaceholder: "<?",
        irTextField: "<",
        ngModel: "=",
    };

    public template: string;

    public compile = InputDirectiveFunctions.compile(this.link); // eslint-disable-line @typescript-eslint/unbound-method

    constructor() {
        this.template = `
            <input
             aa-label="{{irLabel | translate}}"
             aa-field-group="ngModel"
             placeholder="{{irPlaceholder | translate}}"
             typeahead-editable="false"
             autocomplete="off"
             typeahead-template-url="/App/Modules/Gui/Directives/Forms/InputTypeahead/InputTypeaheadResultTemplate.html"
             uib-typeahead="option as option[irTextField] for option in options($viewValue)">
        `;
    }

    public link(
        scope: any,
        instanceElement: JQuery,
        instanceAttributes: IAttributes,
        ngModelController: any,
        transclude?: any,
    ) {
        InputDirectiveFunctions.link(scope, instanceElement, instanceAttributes, ngModelController, transclude);

        scope.options = (searchValue: string) => {
            const results = scope.irOptions
                .filter((item: any) => {
                    if (isNil(searchValue)) {
                        return false;
                    }

                    const searchStr = searchValue.toLowerCase();
                    const itemStr = item[scope.irTextField].toLowerCase();

                    return itemStr.indexOf(searchStr) > -1;
                })
                .slice(0, 8);

            if (scope.createNew) {
                const newItem = {} as any;

                newItem[scope.irTextField] = searchValue;
                results.push(newItem);
            }

            return results;
        };
    }
}

module("mmGui").directive("irInputTypeahead", () => new InputTypeaheadDirective());
